import { NAV_LINKS } from "../data/site";

type SiteNavProps = {
  active: string;
  onNavigate?: () => void;
};

export const SiteNav = ({ active, onNavigate }: SiteNavProps) => (
  <>
    {NAV_LINKS.map(({ id, label }) => (
      <a
        key={id}
        className={active === id ? "active" : undefined}
        href={`#${id}`}
        aria-current={active === id ? "page" : undefined}
        onClick={onNavigate}
      >
        {label}
      </a>
    ))}
  </>
);
